module.exports = __webpack_public_path__ + "media/public/fonts/QanelasLight/QanelasLight-899f7e642c9b99fe39b419b1d225f6ac.svg";